import type { ReactNode } from 'react';

import type { TableSortControl } from '../../lib/table-sort';

interface SortableThProps {
  control: TableSortControl;
  column: string;
  children: ReactNode;
  className?: string;
}

/** Table header cell that sorts its column when clicked. */
export function SortableTh({ control, column, children, className }: SortableThProps) {
  const active = control.sort.key === column;
  const direction = active ? control.sort.direction : null;
  return (
    <th
      className={['sortable-th', active ? `sortable-th-${direction}` : '', className].filter(Boolean).join(' ')}
      onClick={() => control.toggle(column)}
      aria-sort={active ? (direction === 'asc' ? 'ascending' : 'descending') : 'none'}
    >
      <span className="sortable-th-content">
        {children}
        <span className="sortable-th-arrow" aria-hidden="true">{active ? (direction === 'asc' ? '▲' : '▼') : '⇅'}</span>
      </span>
    </th>
  );
}
